import { Model } from 'app/model/backendmodel';
import { AdapterContext, IModel } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { merge } from 'lodash';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { CompressionReadSettings } from 'app/model/pipeline/copysource/compression-read-settings/compression-read-settings';
import { FormatReadSettings } from 'app/model/pipeline/copysource/format-read-settings/format-read-settings';

export async function convertCompressionSettingsToResource(
    compressionProperties: CompressionReadSettings,
    result: Model.FormatReadSettings,
    context: AdapterContext
): Promise<void> {
    if (compressionProperties == null) {
        return undefined;
    }
    const readSettingAdapter = context.asyncAdapterFor(Metamodel.modelOf(compressionProperties));
    if (readSettingAdapter != null) {
        result.compressionProperties = await readSettingAdapter.toResource(compressionProperties);

        // handle raw data
        if (compressionProperties.raw != null) {
            const parsed = JSON.parse(compressionProperties.raw);
            merge(result.compressionProperties, parsed);
        }
    }
}

export async function convertCompressionSettingsToModel(
    resource: Model.CompressionReadSettings,
    entity: FormatReadSettings,
    context: AdapterContext
): Promise<void> {
    if (resource == null) {
        return;
    }
    let compressionSettingsModel: IModel;
    try {
        compressionSettingsModel = Metamodel.modelByName(resource.type);
    } catch {
        // ignore unrecognized compression
    }
    const readSettingAdapter =
        compressionSettingsModel != null ? context.asyncAdapterFor(compressionSettingsModel) : undefined;
    if (readSettingAdapter != null) {
        entity.compressionProperties = await readSettingAdapter.toModel(resource, entity);

        // handle raw data
        if (entity.compressionProperties != null) {
            entity.compressionProperties.raw = JSON.stringify(
                await ValueAdapter.remainder(context, resource, compressionSettingsModel)
            );
        }
    }
}
